"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = exports.tokensValidationSchema = exports.tokenValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.tokenValidationSchema = (0, yup_1.object)().shape({
    tokenId: yup_rules_eth_1.bigNumberValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
    metadata: yup_rules_1.jsonValidationSchema,
});
exports.tokensValidationSchema = (0, yup_1.object)().shape({
    tokens: (0, yup_1.array)().of(exports.tokenValidationSchema).required("form.validations.valueMissing"),
});
exports.validationSchema = (0, yup_1.object)().shape({
    files: (0, yup_1.array)().min(1, "form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map